export default __webpack_public_path__ + "static/media/icon-close.75eaf872.svg";